import { Pill } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";

import { STATUS_CONFIG } from "../constants";
import { type ProfessionalReferenceStatus } from "../types";

interface ProfessionalReferencesStatusPillProps {
  status: ProfessionalReferenceStatus;
}

export function ProfessionalReferencesStatusPill({
  status,
}: ProfessionalReferencesStatusPillProps) {
  const statusConfig = STATUS_CONFIG[status];

  if (!isDefined(statusConfig)) {
    return null;
  }

  const { label, intent } = statusConfig;

  return (
    <Pill
      size="small"
      label={label}
      backgroundColor={(theme) => theme.palette.intent?.[intent]?.background}
      color={(theme) => theme.palette.intent?.[intent]?.text}
      iconColor={(theme) => theme.palette.intent?.[intent]?.icon}
      sx={{ width: "fit-content" }}
    />
  );
}
